import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext.js";
import "./styles/AdminEdit.css";

const AdminAddUser = () => {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();

  const [userData, setUserData] = useState({
    username: "",
    display_name: "",
    email: "",
    role: "freemium",
    password: ""
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (!userData.username.trim()) {
      setError("Username is required");
      setLoading(false);
      return;
    }
    if (!userData.password || userData.password.length < 4) {
      setError("Password must be at least 4 characters");
      setLoading(false);
      return;
    }

    try {
      const resp = await fetch("/api/admin/users", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(userData)
      });
      const data = await resp.json();
      if (!resp.ok) {
        throw new Error(data.message || "Failed to create user");
      }
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-layout">
      <div className="admin-layout-inner">
        <div className="admin-page-header">
          <h1>Add New User</h1>
          <p>Create a new user account</p>
        </div>

        {error && <div className="admin-alert admin-alert-error">{error}</div>}

        <div className="admin-card">
          <div className="admin-card-body">
            <form className="admin-form" onSubmit={handleSubmit}>
              <div className="admin-form-group">
                <label className="admin-form-label">Username *</label>
                <input className="admin-input" name="username" value={userData.username} onChange={handleChange} required placeholder="Enter username" />
              </div>

              <div className="admin-form-group">
                <label className="admin-form-label">Display Name</label>
                <input className="admin-input" name="display_name" value={userData.display_name} onChange={handleChange} placeholder="Name shown on articles" />
              </div>

              <div className="admin-form-group">
                <label className="admin-form-label">Email</label>
                <input className="admin-input" name="email" value={userData.email} onChange={handleChange} type="email" placeholder="user@example.com" />
              </div>

              <div className="admin-form-group">
                <label className="admin-form-label">Password *</label>
                <input className="admin-input" name="password" type="password" value={userData.password} onChange={handleChange} required placeholder="Minimum 4 characters" />
              </div>

              <div className="admin-form-group">
                <label className="admin-form-label">Role *</label>
                <select className="admin-input" name="role" value={userData.role} onChange={handleChange} required>
                  <option value="admin">Admin</option>
                  <option value="journalist">Journalist</option>
                  <option value="reporter">Reporter</option>
                  <option value="user">Subscriber</option>
                  <option value="freemium">Freemium</option>
                </select>
              </div>

              <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
                <button type="submit" className="admin-btn admin-btn-primary" disabled={loading}>
                  {loading ? "Creating..." : "Create User"}
                </button>
                <button type="button" className="admin-btn admin-btn-ghost" onClick={() => navigate("/admin/dashboard")}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAddUser;
